import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMonitors = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.61426 15C3.80364 15.5213 4.03509 16.0221 4.30273 16.5H1.25C0.835786 16.5 0.5 16.1642 0.5 15.75C0.5 15.3358 0.835786 15 1.25 15H3.61426ZM6.5 16.5H6.07031C5.74338 16.0314 5.46184 15.5294 5.23047 15H6.5V16.5ZM3.03027 10.75C3.01235 10.9977 3 11.2477 3 11.5C3 11.7523 3.01235 12.0023 3.03027 12.25H1.25C0.835786 12.25 0.5 11.9142 0.5 11.5C0.5 11.0858 0.835786 10.75 1.25 10.75H3.03027ZM5.5 12.25H4.53418C4.51318 12.0027 4.5 11.7527 4.5 11.5C4.5 11.2473 4.51318 10.9973 4.53418 10.75H5.5V12.25ZM4.30273 6.5C4.03509 6.97792 3.80364 7.47873 3.61426 8H1.25C0.835786 8 0.5 7.66421 0.5 7.25C0.5 6.83579 0.835786 6.5 1.25 6.5H4.30273ZM5.5 8H5.23047C5.31399 7.80889 5.40351 7.62119 5.5 7.4375V8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.25 2.75C18.0825 2.75 22 6.66751 22 11.5C22 13.646 21.2275 15.6116 19.9453 17.1338L23.2803 20.4697C23.5732 20.7626 23.5732 21.2374 23.2803 21.5303C22.9874 21.8232 22.5126 21.8232 22.2197 21.5303L18.8838 18.1953C17.3616 19.4775 15.396 20.25 13.25 20.25C8.41751 20.25 4.5 16.3325 4.5 11.5C4.5 6.66751 8.41751 2.75 13.25 2.75ZM13.25 4.25C9.24594 4.25 6 7.49594 6 11.5C6 15.5041 9.24594 18.75 13.25 18.75C17.2541 18.75 20.5 15.5041 20.5 11.5C20.5 7.49594 17.2541 4.25 13.25 4.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 8.25H16.25C16.6642 8.25 17 8.58579 17 9C17 9.41421 16.6642 9.75 16.25 9.75H6V8.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 13.25H13.25C13.6642 13.25 14 13.5858 14 14C14 14.4142 13.6642 14.75 13.25 14.75H6V13.25Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconMonitors as ReactComponent };
